import createEnum from 'scripts/lib/create_enum';

const LiveboardType = createEnum('AGENTS', 'PEOPLE_MATCH', 'SUMMARY', 'TOPICS');

export default LiveboardType;
